module.exports = __webpack_public_path__ + "static/img/IMG_20160615_002243.2ceb3dde.jpg";